 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/cover'
 import TEXTTITLE_PAGE from '@/components/text/title_page'
 import NAV from '@/components/nav'
 import TEXTCH001 from '@/components/text/ch001'
 import TEXTCH002 from '@/components/text/ch002'
 import TEXTCH003 from '@/components/text/ch003'
 import TEXTCH004 from '@/components/text/ch004'
 import TEXTCH005 from '@/components/text/ch005'
 import TEXTCH006 from '@/components/text/ch006'
 import TEXTCH007 from '@/components/text/ch007'
 import TEXTCH008 from '@/components/text/ch008'
 import TEXTCH009 from '@/components/text/ch009'
 import TEXTCH010 from '@/components/text/ch010'
 import TEXTCH011 from '@/components/text/ch011'
 import TEXTCH012 from '@/components/text/ch012'
 import TEXTCH013 from '@/components/text/ch013'
 import TEXTCH014 from '@/components/text/ch014'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/nav",
 			"name" : "nav",
 			"component" : NAV
 		},
 		{
 			"path" : "/text/ch001",
 			"name" : "text/ch001",
 			"component" : TEXTCH001
 		},
 		{
 			"path" : "/text/ch002",
 			"name" : "text/ch002",
 			"component" : TEXTCH002
 		},
 		{
 			"path" : "/text/ch003",
 			"name" : "text/ch003",
 			"component" : TEXTCH003
 		},
 		{
 			"path" : "/text/ch004",
 			"name" : "text/ch004",
 			"component" : TEXTCH004
 		},
 		{
 			"path" : "/text/ch005",
 			"name" : "text/ch005",
 			"component" : TEXTCH005
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js